import React from 'react';
import { Button } from '@forge/common';
import { useTranslation } from 'react-i18next';

interface ActivityErrorStateProps {
  onRefresh: () => void;
  message: string;
  className?: string;
}

const ActivityErrorState: React.FC<ActivityErrorStateProps> = ({
  onRefresh,
  message,
  className = 'tw-flex tw-flex-col tw-items-center tw-justify-center tw-flex-1 tw-gap-4 tw-py-12',
}) => {
  const { t } = useTranslation();
  return (
    <div className={className} data-testid="activity-error-state">
      <p className="tw-text-sm activity-text-secondary tw-m-0">{message}</p>
      <Button variant="secondary" onClick={onRefresh} data-testid="activity-refresh-btn">
        {t('refresh')}
      </Button>
    </div>
  );
};

export default ActivityErrorState;
